import { useSelector } from 'react-redux';

export default ({ children }) => {
  const role = useSelector(state => state.role);
  return role === 'admin' ? children : null;
};
